"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "element", "parentElement", "getRef", "useWindow", "useCapture", "initialLoad", "onScroll"];
var defaultProps = {
  element: 'div',
  useWindow: true,
  useCapture: false,
  initialLoad: false,
  parentElement: null // the default is the parent element of the current element
};
function Scroll(_ref) {
  var children = _ref.children,
    element = _ref.element,
    parentElement = _ref.parentElement,
    getRef = _ref.getRef,
    useWindow = _ref.useWindow,
    useCapture = _ref.useCapture,
    initialLoad = _ref.initialLoad,
    onScroll = _ref.onScroll,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var scrollComponentRef = _react["default"].useRef(null);
  // A function that checks if the browser supports the `passive` event listener option
  var eventListenerOptions = _react["default"].useCallback(function () {
    var passiveSupported = function () {
      var passive = false;
      var testOptions = {
        get passive() {
          passive = true;
        }
      };
      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }();
    return {
      useCapture: useCapture,
      passive: passiveSupported ? true : false
    };
  }, [useCapture]);

  // A function that listens to the scroll event and calls the `onScroll` callback
  var scrollListener = _react["default"].useCallback(function () {
    var element = scrollComponentRef.current;
    var scrollElement = useWindow ? window : getParentElement(element);
    var scrollTop = scrollElement.scrollTop || scrollElement.pageYOffset || 0;
    onScroll && onScroll(scrollTop);
  }, [onScroll, useWindow]);
  var getParentElement = _react["default"].useCallback(function (element) {
    // return the parent element
    var scrollParent = parentElement && parentElement;
    if (scrollParent != null) {
      return scrollParent;
    }
    return element && element.parentNode;
  }, [parentElement]);

  // add scroll listener
  var attachScrollListener = _react["default"].useCallback(function () {
    var parent = getParentElement(scrollComponentRef.current);
    if (!parent) {
      return;
    }
    var scrollElement = useWindow ? window : parent;
    var options = eventListenerOptions();
    scrollElement.addEventListener('mousewheel', mousewheelListener, options);
    scrollElement.addEventListener('scroll', scrollListener, options);
    scrollElement.addEventListener('resize', scrollListener, options);
    return function () {
      scrollElement.removeEventListener('mousewheel', mousewheelListener, options);
      scrollElement.removeEventListener('scroll', scrollListener, options);
      scrollElement.removeEventListener('resize', scrollListener, options);
    };
  }, [getParentElement, eventListenerOptions, useWindow, scrollListener]);
  var detachMousewheelListener = _react["default"].useCallback(function () {
    var scrollElement = useWindow ? window : scrollComponentRef.current && scrollComponentRef.current.parentNode;
    var options = eventListenerOptions();
    scrollElement && scrollElement.removeEventListener('mousewheel', mousewheelListener, options);
  }, [eventListenerOptions, useWindow]);
  var mousewheelListener = _react["default"].useCallback(function (e) {
    if (e.deltaY === 1 && !eventListenerOptions().passive) {
      e.preventDefault();
    }
  }, [eventListenerOptions]);
  _react["default"].useEffect(function () {
    var cleanup = attachScrollListener();
    return function () {
      cleanup && cleanup();
      detachMousewheelListener();
    };
  }, [attachScrollListener, detachMousewheelListener]);
  _react["default"].useEffect(function () {
    if (initialLoad) {
      scrollListener();
    }
  }, [initialLoad, scrollListener]);
  return /*#__PURE__*/_react["default"].createElement(element, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, props), {}, {
    ref: function ref(node) {
      scrollComponentRef.current = node;
      getRef && getRef(node);
    }
  }), children);
}
Scroll.defaultProps = defaultProps;
var _default = exports["default"] = Scroll;